import { labelMapping, LabelType } from '../pipes/PrintLabel';

export const getItemByLabel = (labelType: LabelType, value: string, options: Array<Record<string, any>>) => {
  if (!labelType || !value || !options?.length) return null;

  const getItem = labelMapping[labelType];
  return options.find((option) => getItem(option).toLowerCase() === value.toLowerCase());
};
